module.exports = __webpack_public_path__ + "static/media/bg3.e3b0d728.jpg";